var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowForward = function SvgArrowForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.517 1.026a.824.824 0 0 1 1.164 0l4.392 4.392a.824.824 0 0 1 0 1.164l-4.392 4.392A.824.824 0 0 1 7.517 9.81l2.986-2.986H1.51a.824.824 0 0 1 0-1.647h8.992L7.517 2.19a.824.824 0 0 1 0-1.164Z",
    fill: "currentColor"
  })));
};
export default SvgArrowForward;